export const HOUR_OPTIONS = Array.from({ length: 24 }, (_, index) =>
    String(index).padStart(2, '0')
)

export const MINUTE_OPTIONS = Array.from({ length: 12 }, (_, index) =>
    String(index * 5).padStart(2, '0')
)

const LEGACY_RESERVE_TIME_MAP = {
    1: { reserveHour: '20', reserveMinute: '00' },
    2: { reserveHour: '12', reserveMinute: '50' },
}

// 예약 시간 입력은 숫자 문자열을 두 자리로 맞추는 기존 동작을 유지한다.
export const formatReserveValue = (value) => {
    if (value === null || value === undefined || value === '') {
        return ''
    }

    return String(Number(value)).padStart(2, '0')
}

export const getReserveTimeFromDetail = ({ reserveHour, reserveMinute, timeType }) => {
    if (reserveHour !== null && reserveHour !== undefined && reserveMinute !== null && reserveMinute !== undefined) {
        return {
            reserveHour: formatReserveValue(reserveHour),
            reserveMinute: formatReserveValue(reserveMinute),
        }
    }

    return LEGACY_RESERVE_TIME_MAP[timeType] || { reserveHour: '', reserveMinute: '' }
}

export const getLegacyTimeTypeFromReserveTime = (reserveHour, reserveMinute) => {
    const parsedHour = Number(reserveHour)
    const parsedMinute = Number(reserveMinute)

    if (parsedHour === 20 && parsedMinute === 0) {
        return 1
    }

    if (parsedHour === 12 && parsedMinute === 50) {
        return 2
    }

    return null
}

export const formatReserveTime = (reserveHour, reserveMinute, timeType) => {
    const formattedHour = formatReserveValue(reserveHour)
    const formattedMinute = formatReserveValue(reserveMinute)

    if (formattedHour && formattedMinute) {
        return `${formattedHour}:${formattedMinute}`
    }

    const legacyReserveTime = LEGACY_RESERVE_TIME_MAP[timeType]

    if (!legacyReserveTime) {
        return ''
    }

    return `${legacyReserveTime.reserveHour}:${legacyReserveTime.reserveMinute}`
}
